import angular from 'angular';

let customFiltersModule = angular.module('customFilters', [])

    .filter('timestampConvert', ()=> {
        return (input)=> {
            var d = new Date(input * 1000),
                yyyy = d.getFullYear(),
                mm = ('0' + (d.getMonth() + 1)).slice(-2),
                dd = ('0' + d.getDate()).slice(-2);
            return dd + '/' + mm + '/' + yyyy;
        }
    })
    .name;

export default customFiltersModule;